/** Gut body connections copy that the results portal and the PDF report share. */
export const GUT_BODY_CONNECTIONS_COPY = {
  title: 'Gut-body connections',
  subtitle:
    'Discover connections between your health and your microbiome report.',
  disclaimerTitle: 'This test does not diagnose any health conditions.',
  disclaimerBody:
    'This is a wellness test, not a diagnostic test. The results show microbiome associations with health conditions, not causes. Multiple factors including genetics, diet, and lifestyle can contribute to risk.',
};
